import React from "react";
import "./WinnerModal.css";

export default function WinnerModal({ numero, onClose }) {
  return (
    <div className="winner-overlay">
      <div className="winner-box">
        <h1 className="winner-title">🎉 GANADOR 🎉</h1>

        <p className="winner-text">Eres el cliente número</p>

        <div className="winner-number">{numero}</div>

        <p className="winner-prize">🎁 ¡Tienes un premio! 🎁</p>

        <p className="winner-condiciones">Aplica Condiciones y Restricciones</p>

        <button className="winner-btn" onClick={onClose}>
          Reclamar en Caja
        </button>
      </div>
    </div>
  );
}
